import { PageTemplate } from '@ui/templates';
import { InDeveloping } from '@@/common/components/in-developing';

import styles from './index.module.css';

export function ConservationPage() {
  return (
    <PageTemplate className={styles.root} header="Консервация">
      <InDeveloping />
    </PageTemplate>
  );
}
